<template>    
    <v-container fluid  class="main">
      <LeftMenu/>   
      <v-layout row wrap>  
        <v-flex xs12>
          <Progress :show="this.showProgress" />
        </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs10>       
            <v-tabs
              v-model="tab"
              fixed-tabs          
              background-color="white"
              color="black accent-4"
              left
            >
              <v-tab key="profile">
                {{personnelFullname}}
              </v-tab>
              <v-tab key="transactions">
                Transactions
              </v-tab> 
              <v-tab key="earnings">
                Earnings
              </v-tab> 
              <v-tab key="manuals">
                Manuals
              </v-tab> 
              <v-tab key="salary">
                Salary - Bonus
              </v-tab>   
              <v-tab key="performance">
                Performance
              </v-tab>  
              <v-tab key="documents">
                Documents
              </v-tab>          
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item
                key="profile"
              >
                <v-layout row wrap>   
                  <v-flex xs12>&nbsp;</v-flex>
                  <v-flex xs1></v-flex>
                  <v-flex xs10>
                    <v-data-table
                      :headers="headersSummary"
                      :items="summaryFormatted"
                      :items-per-page="50"
                      sort-by="orderId"
                      :sort-desc="true"
                      class="elevation-1"
                      :search="search"
                      :custom-filter="filterOnlyCapsText"
                      >
                      <template v-slot:top>                  
                        <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
                      </template> 
                      <template v-slot:item.periodText="{ item }">                  
                        <v-chip v-if="item.summary"  dark>{{ item.periodText }}</v-chip>   
                        <div v-if="!item.summary">
                          {{ item.periodText }}
                        </div>               
                      </template>                 
                      <template v-slot:body.append>                    
                      </template>                             
                    </v-data-table>
                  </v-flex>
                  <v-flex xs1></v-flex>
                </v-layout>          
              </v-tab-item>
              <v-tab-item
                key="transactions"
              >
                <v-layout row wrap>   
                  <v-flex xs12>&nbsp;</v-flex>
                  <v-flex xs1> </v-flex>
                  <v-flex xs10>
                    <Xlsx filename="transactions" :items="xlsxItems"  :headers="xlsxHeaders" />  
                    <v-data-table
                      :headers="headersTransaction"
                      :items="transactionsFormatted"
                      :items-per-page="50"
                      sort-by="transactionDate"
                      item-key="relatedItemId"
                      :sort-desc="true"
                      class="elevation-1"
                      :search="search"
                      :custom-filter="filterOnlyCapsText"
                      >
                      <template v-slot:top>    
                          <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>        
                      </template> 
                      <template v-slot:body.append>                    
                      </template>                             
                    </v-data-table>
                  </v-flex>
                  <v-flex xs1></v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item
                key="earnings"
              >
                <v-layout row wrap>   
                  <v-flex xs12>&nbsp;</v-flex>
                  <v-flex xs1></v-flex>
                  <v-flex xs10>
                    <v-data-table
                      :headers="headersEarnings"
                      :items="earningsFormatted"
                      :items-per-page="50"
                      sort-by="earningDate"
                      :sort-desc="true"
                      class="elevation-1"
                      :search="search"
                      :custom-filter="filterOnlyCapsText"
                      >
                      <template v-slot:top>                  
                        <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
                      </template> 
                      <template v-slot:body.append>                    
                      </template>                             
                    </v-data-table>
                  </v-flex>
                  <v-flex xs1></v-flex>
                </v-layout>
              </v-tab-item>

              <v-tab-item key="manuals">
                <v-layout row wrap>   
                  <v-flex xs12>&nbsp;</v-flex>
                  <v-flex xs1></v-flex>
                  <v-flex xs10>
                    <v-data-table
                      :headers="headersManual"
                      :items="manualsFormatted"
                      :items-per-page="50"
                      item-key="recordDate"
                      sort-by="recordDate"
                      :sort-desc="true"
                      class="elevation-1"
                      :search="search"
                      :custom-filter="filterOnlyCapsText"
                      >
                      <template v-slot:top>
                        <v-toolbar flat color="white">
                          <v-toolbar-title>Manuals</v-toolbar-title>
                          <v-divider
                            class="mx-4"
                            inset
                            vertical
                          ></v-divider>
                          <v-spacer></v-spacer>
                          <v-dialog v-model="dialogManual" max-width="900px">
                            <template v-slot:activator="{ on }">
                              <v-btn color="primary" dark class="mb-2" v-on="on">New Manual</v-btn>
                            </template>
                            <v-card>
                              <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-container grid-list-md>
                                  <v-layout wrap>
                                    <v-flex xs12 sm6 md6>
                                      <DatePicker picker-label="Record Date" :date-value="editedManualItem.recordDate" @dateSelected="editedManualItem.recordDate=$event" />
                                    </v-flex> 
                                    <v-flex xs12 sm6 md6>
                                      <v-combobox
                                        :items="manualTypeList"
                                        label="Select Type"
                                        v-model="editedManualItem.type"
                                        item-text="text"
                                        single-line
                                        return-object
                                      ></v-combobox>
                                    </v-flex> 
                                    <v-flex xs12 sm6 md6>
                                      <v-currency-field :key="editedManualItem.id" v-model="editedManualItem.amount" label="Amount"></v-currency-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <v-combobox
                                      :items="currencyListWithText"
                                      label="Select Currency"
                                      v-model="editedManualItem.currency"
                                      item-text="text"
                                      single-line
                                      return-object
                                    ></v-combobox>
                                    </v-flex>  
                                    <v-flex xs12 sm6 md12>
                                      <v-textarea v-model="editedManualItem.explanation"  :outlined="true"
                                      :auto-grow="true" :clearable="true"
                                      label="Explanation"></v-textarea>
                                    </v-flex>                                                                                                                                                                                                                         
                                  </v-layout>
                                </v-container>
                              </v-card-text>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="error" dark class="mb-2" @click="closeManual">Cancel</v-btn>
                                <v-btn color="success" dark class="mb-2" @click="saveManual">Save</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-toolbar>
                        <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
                      </template> 
                      <template v-slot:body.append>                    
                      </template>             
                      <template v-slot:item.action="{ item }">              
                        <v-icon                  
                          @click="editItemManual(item)">
                          mdi-table-edit
                        </v-icon>
                        <v-icon                  
                          @click="deleteItemManual(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs1></v-flex>
                </v-layout>
              </v-tab-item>

              <v-tab-item key="salary">
                <v-layout row wrap>   
                  <v-flex xs12>&nbsp;</v-flex>
                  <v-flex xs1></v-flex>
                  <v-flex xs10>
                    <v-row
                      class="pa-0"
                      no-gutters
                    >
                      <v-col  md="6" class="pa-2">
                        <PersonnelSalaries @salaryChanged="refreshSummary"/>
                      </v-col>
                      <v-col md="6" class="pa-2">
                        <PersonnelBonusTypes @bonusTypeChanged="refreshSummary"/>
                      </v-col>
                    </v-row>              
                  </v-flex>
                  <v-flex xs1 />    
                </v-layout>      
              </v-tab-item>
              <v-tab-item key="performance">
                <v-layout row wrap>   
                  <v-flex xs12>&nbsp;</v-flex>
                  <v-flex xs1></v-flex>
                  <v-flex xs10>
                    <v-row
                      class="pa-0"
                      no-gutters
                    >
                      <v-col  md="6" class="pa-2">
                        <PersonnelPerformanceCriterias @performanceCriteriaChanged="refreshSummary"/>
                      </v-col>
                      <v-col md="6" class="pa-2">
                        <PersonnelPerformanceReviewers @performanceReviewerChanged="refreshSummary"/>
                      </v-col>
                    </v-row>              
                  </v-flex>
                  <v-flex xs1 />    
                </v-layout>      
              </v-tab-item>
              <v-tab-item key="documents">
                <v-layout row wrap>   
                  <v-flex xs12>&nbsp;</v-flex>
                  <v-flex xs1></v-flex>
                  <v-flex xs10>
                    <v-row
                      class="pa-0"
                      no-gutters
                    >
                      <v-col  md="12" class="pa-2">
                        <Documents :documents="this.personnel.documents" master-category="PERSONNEL" :folder-id="this.personnel.folderId"
                                :parentRecord="this.personnel.id"  @documentsChanged="getPersonnel"/>
                      </v-col>
                    </v-row>              
                  </v-flex>
                  <v-flex xs1 />    
                </v-layout>      
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
          <v-flex xs1/>
      </v-layout>
    </v-container>
</template>


<script>
import LeftMenu from '../components/LeftMenu';
import PersonnelSalaries from '../views/PersonnelSalaries';
import PersonnelBonusTypes from '../views/PersonnelBonusTypes';
import PersonnelPerformanceCriterias from '../views/PersonnelPerformanceCriterias';
import PersonnelPerformanceReviewers from '../views/PersonnelPerformanceReviewers';
import Documents from '../views/Documents';
import DatePicker from '../components/DatePicker';
import Progress from '../components/Progress';
import formatPrice from '../helpers/formatter';
import formatToDouble from '../helpers/formatToDouble';
import Xlsx from '../components/Xlsx';
const API_URL = 'definitions/';
const PERSONNEL_API_URL = 'definitions/personnel/';
const CURRENCIES_API_URL = 'definitions/currencies';
const MANUAL_TYPES_API_URL = 'definitions/personnelManualTypes';
export default {
    components:{
      LeftMenu,
      DatePicker,
      PersonnelSalaries,
      PersonnelBonusTypes,
      PersonnelPerformanceCriterias,
      PersonnelPerformanceReviewers,
      Documents,
      Progress,
      Xlsx
    },
    data () {
      return {
        tab: null,        
        dialogManual: false,
        showProgress : false,
        search: '',        
        personnel: '',
        personnelFullname : '',
        personnelEarnings: [],
        personnelTransactions: [],
        personnelManuals: [],
        personnelSummary: [],
        currencyList: [],
        manualTypeList:[],
        editedIndex: -1,
        editedItem: {
          model: '',
            category: '',
            explanation: '', 
        },
        editedManualIndex: -1,
        editedManualItem: {},
        defaultItem: {},
        xlsxHeaders: {
          transactionDate : 'Transaction Date' ,
          typeAndId : 'Type - Id'  ,
          explanation : 'Explanation' ,       
          amount : 'Amount' ,        
          currency : 'Currency'
        }
      }
    },
    computed: {      
      headersSummary () {
        return [
          { text: 'Period', align: 'center', sortable: true, value: 'periodText' },                
          { text: 'Balance', align: 'right', value: 'balanceFormatted' },
          { text: 'Currency', value: 'currency.code' },
          { text: 'Transactions', align: 'right', sortable: true, value: 'paymentsFormatted' },
          { text: 'Earnings',  align: 'right',value: 'earningsFormatted'  },  
        ]
      },      
      headersManual () {
        return [
          { text: 'Record Date', align: 'center', sortable: true, value: 'recordDate' },
          { text: 'Type', value: 'type.text' },
          { text: 'Amount', align: 'right',  value: 'amountFormatted',  sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },        
          { text: 'Currency', value: 'currency.code' },
          { text: 'Explanation',align: 'left',sortable: true,value: 'explanation'},  
          { text: 'Actions', value: 'action', sortable: false },
        ]
      },
      headersTransaction () {
        return [
          { text: 'Transaction Date', align: 'center', sortable: true, value: 'transactionDate' },
          { text: 'Amount', align: 'right', value: 'amountFormatted'  , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },        
          { text: 'Currency', value: 'currency.code' },
          { text: 'Type - Id', value: 'typeAndId' },
          { text: 'Explanation', value: 'explanation' },
        ]
      },
      headersEarnings () {
        return [
          { text: 'Earning Date', align: 'center', sortable: true, value: 'earningDate' },
          { text: 'Amount', align: 'right', value: 'amountFormatted'  , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },         
          { text: 'Currency', value: 'currency.code' },
          { text: 'Explanation', value: 'explanation' },
        ]
      },
      manualsFormatted(){
        return this.personnelManuals.map((item) => {
          item.amountFormatted = formatPrice(item.amount);
          return item;  
        })
      },      
      summaryFormatted(){
        return this.personnelSummary.map((item) => {          
          if(item.summary){
            item.periodText = item.period.text +'_SUMMARY';
          }else{
            item.periodText = item.period.text +'_'+item.currency.code;
          }          
          item.paymentsFormatted = formatPrice(item.transactionsTotal);
          item.earningsFormatted = formatPrice(item.earningsTotal);
          item.balanceFormatted = formatPrice(item.balanceTotal);
          return item;  
        })
      },      
      transactionsFormatted(){
        return this.personnelTransactions.map((item) => {
          item.amountFormatted = formatPrice(item.amount);
          item.typeAndId = item.type + " - " + item.relatedItemId; 
          return item;  
        })
      },
      xlsxItems(){
      return this.personnelTransactions.map((item) => {
        return {
          transactionDate: item.transactionDate,
          amount: formatPrice(item.amount) ,
          typeAndId : item.type + " - " + item.relatedItemId,
          explanation: item.explanation,
          currency: item.currency.code                  
        }
      });
    },
      earningsFormatted(){
        return this.personnelEarnings.map((item) => {
          item.amountFormatted = formatPrice(item.amount);
          return item;  
        })
      },
      currencyListWithText(){
        return this.currencyList.map((item) => {
          return {
            id: item.id,
            code: item.code,
            text: item.code+' - '+item.text          
          };
        })
      },      
      formTitle () {
        if(this.tab =='0')
          return this.editedIndex === -1 ? 'New Profile' : 'Edit Profile';
        if(this.tab =='1')
          return this.editedIndex === -1 ? 'New Transaction Entry' : 'Edit Transaction Entry';
        if(this.tab =='2')
          return this.editedIndex === -1 ? 'New Earning Entry' : 'Edit Earning Entry';
        if(this.tab =='3')
          return this.editedManualIndex === -1 ? 'New Manual Entry' : 'Edit Manual Entry';
        if(this.tab =='4')
          return this.editedIndex === -1 ? 'New Salary Entry' : 'Edit Salary Entry';
      },
    },
    created() {    
      this.getPersonnel();
      this.getCurrencies();
      this.getManualTypes();
      this.getPersonnelSummary();      
      this.getTransactionHistory();
      //this.getEarningsHistory();
      this.getManuals();
    },
    watch: {      
      dialogManual (val) {
        val || this.closeManual()
      },
    },
    methods: {   
      refreshSummary(){
        this.getPersonnelSummary();
        //this.getEarningsHistory();
      },  
      editItemManual (item) {
        this.editedManualIndex = this.personnelManuals.indexOf(item)
        this.editedManualItem = Object.assign({}, item)
        this.dialogManual = true
      },      
      deleteItemManual (item) {
        if(confirm('Are you sure you want to delete this item?')){
          this.deleteManual(item);
        } 
      },        	
      saveManual () {
        if (this.editedManualIndex > -1) {        
          this.updateManual(this.editedManualItem);
        } else {
          this.addManual(this.editedManualItem);         
        }      
      },
        
      addManual(item){
        this.$axios.post(this.$apiurl + API_URL+'personnelManuals', {
          id : -1,
          personnelId : this.$route.params.id,
          recordDate: item.recordDate,
          currencyId: item.currency ? item.currency.id : null,          
          typeId: item.type ? item.type.id : null,
          explanation: item.explanation,
          amount: item.amount,
        })
        .then(response => {        
          if (response.status === 201) {
            this.personnelManuals.push(this.editedManualItem);  
            this.$radio.$emit('success', {message:'Personnel Manual Added Successfully'});          
            this.closeManual();
            this.getPersonnelSummary();
          } 
        }) 
        .catch(error => {
          console.log(error);
        }); 
      },      
      updateManual(item){
        this.$axios.put(this.$apiurl + API_URL+'personnelManuals', {
          id: item.id,
          personnelId : this.$route.params.id,
          recordDate: item.recordDate,
          currencyId: item.currency.id,
          typeId: item.type.id,
          explanation: item.explanation,
          amount: item.amount,
        })
        .then(response => {
          if (response.status === 200) {
            Object.assign(this.personnelManuals[this.editedManualIndex], this.editedManualItem);
            this.closeManual();
            this.$radio.$emit('success', {message:'Personnel Manual Updated Successfully'});
            this.getPersonnelSummary();
          }         
        }) 
        .catch(error => {
          console.log(error);
        }); 
      },      
      deleteManual(item){
        this.$axios.delete(this.$apiurl + API_URL+'personnelManuals/'+item.id)
        .then(response => {
          if (response.status === 200) {
            const index = this.personnelManuals.indexOf(item)
            this.personnelManuals.splice(index, 1);
            this.$radio.$emit('success', {message:'Personnel Manual Deleted Successfully'});
          }
        }) 
        .catch(error => {
          console.log(error);
        }); 
      },       
      closeManual () {
        this.dialogManual = false
        setTimeout(() => {
          this.editedManualItem = Object.assign({}, this.defaultItem)
          this.editedManualIndex = -1
        }, 300)
      },  
      getPersonnel(){
          this.$axios.get(this.$apiurl + PERSONNEL_API_URL+this.$route.params.id)
            .then(response => {
                this.personnel = response.data;
                this.personnelFullname = response.data.name + " " + response.data.surname;
            }) 
            .catch(error => {
                console.log(error);
            });   
      },
      getPersonnelSummary(){     
        this.showProgress = true;
        this.$axios.get(this.$apiurl + PERSONNEL_API_URL+this.$route.params.id+'/summary')
            .then(response => {
                this.personnelSummary = response.data.summaryRecords;
                this.personnelEarnings = response.data.earnings;
                this.showProgress = false;
            }) 
            .catch(error => {
              this.showProgress = false;
              console.log(error);
            });                         
      },       
      getTransactionHistory(){     
        this.$axios.get(this.$apiurl + PERSONNEL_API_URL+this.$route.params.id+'/transactions')
            .then(response => {
                this.personnelTransactions = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
      }, 
      getEarningsHistory(){     
        this.$axios.get(this.$apiurl + PERSONNEL_API_URL+this.$route.params.id+'/earnings')
            .then(response => {
                this.personnelEarnings = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
      },
      getManuals(){     
        this.$axios.get(this.$apiurl + PERSONNEL_API_URL+this.$route.params.id+'/manuals')
            .then(response => {
                this.personnelManuals = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
      },
      getCurrencies(){     
        this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
      }, 
      getManualTypes(){     
        this.$axios.get(this.$apiurl + MANUAL_TYPES_API_URL)
            .then(response => {
                this.manualTypeList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
      },
      filterOnlyCapsText (value, search) {
        return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
      },
    }
}
</script>
<style scoped>
.summaryItem{
  background-color: grey;
   width: 100%;
  height: 100%; 
  align-content: center
}
.main{
  width: 100%;
  height: 100%;  
}
</style>
